<p-dialog
  [header]="titleText"
  [visible]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="onCancel()"
  [(visible)]="visible"
  [style]="{ width: '40rem' }"
  [appendTo]="'body'"
  styleClass="lib-feedback-dialog"
  logAmplitudeEvent="feedback_dialog_shown"
  [logAmplitudeProps]=""
>
  <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
    <div class="mb-4">
      <p-rating
        id="rating"
        formControlName="rating"
        [stars]="5"
        [style]="{ fontSize: '1.5rem' }"
      ></p-rating>
    </div>
    <div class="flex flex-wrap gap-2 mb-4">
      @for (tag of feedbackProps?.suggestedTags ?? []; track tag) {
        <p-chip
          [label]="tag"
          [removable]="false"
          [styleClass]="
            'tag-chip ' + (isTagSelected(tag) ? 'selected' : 'unselected')
          "
          class="cursor-pointer"
          (click)="toggleTag(tag)"
        ></p-chip>
      }
    </div>

    <div class="mb-4">
      <label for="comment" class="block mb-1 font-medium">{{ commentText }}</label>
      <textarea
        id="comment"
        pTextarea
        formControlName="comment"
        rows="3"
        class="p-inputtext w-full border border-gray-300 rounded p-2"
      ></textarea>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <p-button
        label="Cancel"
        (onClick)="onCancel()"
        [outlined]="true">
      </p-button>
      <p-button type="submit" label="Submit" [disabled]="feedbackForm.invalid"></p-button>
    </div>
  </form>
</p-dialog>
